module.exports = __webpack_public_path__ + "img/vf7.6415ea03.png";